/** external **/
import React, { memo, useEffect, useRef } from "react";
import {
  ChevronDownOutlined,
  ScopeAndSequenceOutlined,
} from "@toddle-edu/ds-icons";
import classNames from "classnames";

/** internal **/
import Accordian from "UIComponents/Accordian";
import WorksheetTextView from "UIComponents/WorksheetTextView";
import { isMobileOrTablet } from "Utils/DeviceDetectHelpers";
import { getIsWorksheetDocEditorEnabled } from "Worksheet/modules/WorksheetFeatureFlags";

/** relative **/
import classes from "./StudentWorksheetInstructions.scss";

const styles = {
  headerStyle: {
    padding: 0,
  },
  arrowStyle: {
    padding: "6px",
  },
  mainContentContainerStyle: {
    padding: 0,
    border: 0,
    margin: "5px 0 0",
  },
};

const getTitleComponent = ({ t }) => (
  <div className={classes.titleContainer}>
    <ScopeAndSequenceOutlined size="xxx-small" />
    <span className="text-label">{t("worksheet:worksheet_instructions")}</span>
  </div>
);

const StudentWorksheetInstructions = memo(props => {
  const { value, t, openInstructions = 0, setRef, isStudentEndMode } = props;
  const containerRef = useRef(null);
  const title = getTitleComponent({ t });
  const customRightArrow = (
    <span className={classes.arrowContainer}>
      <ChevronDownOutlined size="xxx-small" />
    </span>
  );

  const expandedContent = (
    <WorksheetTextView
      value={value}
      mode="view"
      showDocEditor={getIsWorksheetDocEditorEnabled()}
      isRtlAlignmentRequired={true}
    />
  );

  useEffect(() => {
    if (typeof setRef === "function" && isStudentEndMode) {
      setRef(containerRef);
    }
  }, [setRef]);

  const instructionsContainer = classNames(
    classes.studentInstructionsContainer,
    {
      [classes.revampStudentUI]: isStudentEndMode,
      [classes.ipadContainer]: isMobileOrTablet(),
    }
  );
  return (
    <div ref={containerRef} className={instructionsContainer}>
      <Accordian
        title={title}
        headerStyle={styles.headerStyle}
        customRightArrow={customRightArrow}
        arrowStyle={styles.arrowStyle}
        expandedContent={expandedContent}
        mainContentContainerStyle={styles.mainContentContainerStyle}
        showLabelBorder={false}
        isExpanded={openInstructions}
      />
    </div>
  );
});

StudentWorksheetInstructions.displayName = "StudentWorksheetInstructions";

export default StudentWorksheetInstructions;
